<template lang="pug">
.container.fluid.pa-0
    .d-flex.px-3
        //v-autocomplete(
            :items="officeOptions"
            item-value="id"
            outline
            label="sucursal"
            v-model="activeOffice"
            style="width: 50%"
            :disabled="loading || officeOptions.length < 2"
            )
        //v-text-field.ml-2(
            outline
            label="margen masivo"
            placeholder=""
            style="width: 30%"
            :rules="iRules"
            v-model="batchMarginAmount"
            :disabled="loading || !selected.length"
            )
        //v-btn(
            large
            :color="colors.secondary"
            :dark="!loading"
            :disabled="loading || !selected.length"
            @click="batchMarginChange"
            ) Aplicar
        //v-btn(
            large
            :color="colors.secondary"
            :dark="!loading"
            :disabled="loading || !selected.length"
            @click="batchMarginChange"
            ) sumar
    v-toolbar( class='py-3' flat )
        v-select( 
            :disabled='officeOptions.length < 1'
            flat 
            hide-details
            :items='officeOptions'
            item-value='id'
            no-object
            placeholder='Sucursales'
            :readonly='officeOptions.length < 2'
            solo 
            v-model='activeOffice' 
            )
            template( slot='prepend-inner' )
                label.subheading.font-weight-bold Sucursal
        v-float-field(
            class='ml-2' 
            :disabled='selected.length < 1'
            flat
            hide-details
            :items='officeOptions'
            placeholder='Porcentaje'
            prefix= '%',
            :readonly='selected.length < 1'
            reverse
            :rules='iRules'
            v-model='batchMarginAmount' 
            solo           
            )
            template( slot='append' )
                label.subheading.font-weight-bold Margen masivo
        v-btn( 
            color='secondary' 
            depressed 
            :disabled='selected.length < 1'
            large
            @click="batchMarginChange"
            ) aplicar &nbsp;
            v-icon check_circle
        v-btn( 
            color='success' 
            depressed 
            :disabled='selected.length < 1'
            large
            @click="batchMarginAdd"
            ) sumar &nbsp;
            v-icon add_circle
    ModelDataTable(
        ref="table"
        :headers="headers"
        :service="service"
        :filters="filters"
        checkable
        editable
        :mapper="mapper"
        :parser='parser'
        @selected="setSelected"
        no-actions
        :defaultLimit="100"
        @busy="handleBusy"
        )
</template>

<script>
import ModelDataTable from '../../../components/reusable_components/next/ModelDataTable'
import { CrudCreateButton } from '@/components/reusable_components'
import VFloatField from '@/components/reusable_components/next/Fields/FloatField'
import service from '../../../services/api/product/modelTableService'
import headers from './marginsHeaders'
import GBranchOffice from '../../../models/General/GBranchOffice'
import { mapActions, mapState, mapGetters } from 'vuex'
import axios from 'axios'
import filtersMargin from './filtersMargin'
const SUBMIT_ROUTE =
    process.env.VUE_APP_API_ROUTE + '/wh_product/massive_margin'

function initialState() {
    return {
        // select
        officeOptions: [],
        activeOffice: 0,

        //input
        batchMarginAmount: '',

        // table
        service,
        headers,
        selected: [],

        loading: false,

        dataToSend: null,
        filters: filtersMargin,
        iRules: [
            val => (isNaN(val) ? 'debe ser numérico' : true),
            val => {
                if (isNaN(val) === false && val !== '' ) {
                    if (val < 1 || val > 1000) {
                        return 'El margen debe ser entre[1 - 1000]'
                    }
                    return true
                }
            },
        ],
    }
}

export default {
    components: { ModelDataTable, CrudCreateButton, VFloatField },
    data: () => initialState(),
    computed: {
        mapper() {
            let office = this.activeOffice
            if (office === 0) office = 1
            let mapper = f => {
                f.activeOffice = office
                f.newMargin = f.newMargin
                    ? f.newMargin
                    : !f || !f.officeMargin || isNaN(f.officeMargin)
                    ? 0
                    : f.officeMargin
                return f
            }
            console.log(mapper, 'mapper')
            return mapper
        },
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        ...mapState('AuthModule', { user: 'user' }),
        ...mapGetters('AuthModule', { userOfficeID: 'userOfficeID' }),
    },
    methods: {
        parser(r) {
            if (!this.activeOffice) {
                r.data = r.data.filter(item => {
                    //
                    const equalPrice = item.sale_prices.reduce((equal, price, idx) => (idx + 1) < item.sale_prices.length ? price.sale_price === item.sale_prices[idx+1].sale_price : equal, true)
                    const equalCost = item.branch_offices.reduce((equal, price, idx) => (idx + 1) < item.branch_offices.length ? price.cost_price === item.branch_offices[idx+1].cost_price : equal, true)
                    //
                    return equalPrice && equalCost
                })
            }
            return r
        },
        setSelected(e) {
            this.selected = e.selected
        },
        batchMarginChange() {
            if (!this.batchMarginAmount || isNaN(this.batchMarginAmount)) return
            this.selected = this.selected.map(f => {
                f.newMargin = this.batchMarginAmount
                return f
            })
        },
        batchMarginAdd() {
            if (!this.batchMarginAmount || isNaN(this.batchMarginAmount)) return
            this.selected = this.selected.map(f => {
                f.newMargin += this.batchMarginAmount
                return f
            })
        },
        submitSingle() {
            let data = this.formatOfficePriceChanges()
            if (data.length) {
                this.handleErrorsArray(data)
                return
            } else {
                this.dataToSend = data
                this.resetSnackbarState()
                this.setMessageConfirmSnack(`CAMBIAR PRECIOS`)
                this.initSnackbar(
                    this.fillSnack(
                        'warning',
                        'CONFIRMAR',
                        '¿Está seguro de realizar este cambio de precio?'
                    )
                )
            }
        },
        submitGlobal() {
            let data = []
            let err = false
            this.officeOptions
                .filter(o => o.id !== 0)
                .forEach(o => {
                    if (err) return
                    let d = this.formatOfficePriceChanges(
                        o.id,
                        this.items,
                        o.name
                    )
                    if (d.length) {
                        this.handleErrorsArray(d)
                        err = true
                    }
                    data.push(d)
                })
            if (err) return
            this.dataToSend = data
            this.resetSnackbarState()
            this.setMessageConfirmSnack(`CAMBIAR PRECIOS GLOBAL`)
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'CONFIRMAR',
                    '¿Está seguro de realizar este cambio de precio para TODAS las sucursales?'
                )
            )
        },
        submit() {
            if (this.activeOffice !== 0) {
                this.submitSingle()
            } else {
                this.submitGlobal()
            }
        },
        handleErrorsArray(errors) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('error', 'Error', errors.join(', '))
            )
            this.loading = false
        },
        formatOfficePriceChanges(
            office = this.activeOffice,
            items = this.selected,
            officeName = null
        ) {
            let errors = []
            if (!office) errors.push(['No hay una sucursal seleccionada'])
            if (!items || !items.length)
                errors.push(['No hay productos seleccionados'])
            if (errors.length) return errors
            let formatted = {
                g_branch_office_id: office,
                products: items.map(i => {
                    i.activeOffice = office
                    let frm = {}
                    let getError = message => `El producto ${i.name} ${message}`
                    if (officeName)
                        getError = message =>
                            `El producto ${
                                i.name
                            } ${message} - SUCURSAL: ${officeName}`
                    if (i.id !== 0 && !i.id)
                        errors.push(getError('no tiene ID'))
                    frm.wh_product_id = i.id
                    if (!i.newMargin || isNaN(i.newMargin))
                        errors.push(getError('no tiene un margen configurado'))
                    frm.gains_margin = i.newMargin
                    if (
                        i.officeCostPrice == 0 ||
                        !i.officeCostPrice ||
                        isNaN(i.officeCostPrice)
                    )
                        errors.push(
                            getError('presenta errores en el precio costo')
                        )
                    frm.sale_price = this.calcSalePriceByMargin(
                        i.officeCostPrice,
                        i.newMargin
                    )
                    return frm
                }),
            }
            if (errors.length) return errors
            return formatted
        },
        submitOfficePriceChanges() {},
        calcNetByMargin: (cost, margin) => {
            return parseFloat(cost) / (1 - margin)
        },
        calcSalePriceByMargin(cost, margin) {
            //
            let aux = Math.round(
                parseInt(cost) * (margin / 100) + parseInt(cost)
            )
            return Math.round(aux * 1.19)
        },
        storePriceChange(data = this.dataToSend) {
            return axios.put(SUBMIT_ROUTE, data)
        },
        storeGlobalPriceChange(data = this.dataToSend) {
            return Promise.all(
                data.map(function(d) {
                    return axios.put(SUBMIT_ROUTE, d)
                })
            )
        },
        handleSuccess() {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Precios cambiados exitosamente'
                )
            )
            this.batchMarginAmount = ''
            this.$refs.table.refresh()
            //this.resetView()
        },
        handleError(e) {
            this.loading = false
            let message = 'Ha ocurrido un error'
            if (e.message) message = e.message
            if (e.error) message = e.error
            if (e.response) {
                if (e.response.error) message = e.response.error
                if (e.response.data && e.response.data.error)
                    message = e.response.data.error
                if (
                    e.response.data &&
                    e.response.data.data &&
                    e.response.data.data.error
                )
                    message = e.response.data.data.error
            }
            if (e.data) {
                if (e.data.error) message = e.data.error
                if (e.data.data && e.data.data.error)
                    message = e.data.data.error
            }
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('error', 'Error', message))
        },
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        hasRole(role) {
            if (!this.user || !this.user.roles || !this.user.roles.lenght)
                return false
            return this.user.roles.some(r => r === role)
        },
        async fetchInitialData() {
            this.loading = true
            // TODO: Set right role when it's defined
            if (true||this.hasRole('adm_all_ventas')) {
                let response = await GBranchOffice.get()
                this.loading = false
                this.officeOptions = [
                    { text: 'TODAS', id: 0 },
                    ...response.data.map(o => {
                        o.text = `${o.name}  -  ${o.address}`
                        return o
                    }),
                ]
            } else {
                if (!this.userOfficeID) return
                let response = await GBranchOffice.find(this.userOfficeID)
                this.officeOptions = [
                    {
                        text: `${response.name} - ${response.address}`,
                        id: this.userOfficeID,
                    },
                ]
                this.activeOffice = this.userOfficeID
            }
        },
        async resetView() {
            this.$router.push()
        },
        handleBusy(e) {
            this.loading = !!e
            if (!e) {
                this.$refs.table.selected = []
            }
        },
    },
    watch: {
        async responseConfirm(val) {
            if (val === `CAMBIAR PRECIOS`) {
                this.resetSnackbarState()
                this.storePriceChange()
                    .then(this.handleSuccess)
                    .catch(this.handleError)
            } else if (val === `CAMBIAR PRECIOS GLOBAL`) {
                this.resetSnackbarState()
                this.storeGlobalPriceChange()
                    .then(this.handleSuccess)
                    .catch(this.handleError)
            }
        },
    },
    async created() {
        this.setTitleTopBar('Cambio de precio por margen')
        this.$setItemsTopBar([
            {
                text: 'guardar cambios',
                icon: 'save',
                color: 'success',
                //can: 'CREATE_PRODUCT_ITEM',
                action: this.submit,
            },
        ])
        await this.fetchInitialData()
    },
}
</script>
